import { required } from "@corporate-tailwind/corp-form";

export class OrderApprovalRangeDto {
    minAmount: number | null = null;
    maxAmount: number | null = null;
    // isAmountAlert: boolean | null = null;
}

export class OrderApprovalRangeSchema extends OrderApprovalRangeDto {
    static schema = {
            minAmount: { type: Number, builderOption: required },
            maxAmount: { type: Number, builderOption: required }
            // isAmountAlert: { type: Boolean, builderOption: required }
        };
}